import React from "react";
import { Document, Page } from "react-pdf";
import { useNavigate } from "react-router-dom";
import { useAuthToken } from "../AuthProvider";
import { toast } from "react-toastify";
import arrow_forward from "../img/arrow_forward.svg";
import arrow_back from "../img/arrow_back.svg";

/* eslint-disable @typescript-eslint/ban-types */
interface ResumeDisplayProps {
  resumeData: ResumeContents;
  numPages: number;
  width: number;
}
/* eslint-enable @typescript-eslint/ban-types */

export interface ResumeContents {
  contents: any;
}

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const ResumeDisplay: React.FC<ResumeDisplayProps> = ({
  resumeData,
  numPages,
  width,
}) => {
  const [shownPage, setShownPage] = React.useState<number>(1);

  const pdfData = React.useMemo(() => {
    return { data: atob(resumeData.contents) };
  }, [resumeData.contents]);

  console.log(width);

  return (
    <div className="flex flex-col items-center">
      {numPages == 0 && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white bg-opacity-75">
          <svg
            aria-hidden="true"
            className="inline h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      )}
      {resumeData.contents && (
        <Document file={pdfData} options={options}>
          <div className="flex min-h-full flex-row justify-center rounded-t-xl bg-white pt-2">
            <button
              className="mr-2"
              onClick={() => {
                if (shownPage > 1) {
                  setShownPage(shownPage - 1);
                }
              }}
            >
              <img src={arrow_back} />
            </button>
            <h1 className="font-code font-bold text-black">
              Page {shownPage} of {numPages}
            </h1>
            <button
              className="ml-2"
              onClick={() => {
                if (shownPage < numPages) {
                  setShownPage(shownPage + 1);
                }
              }}
            >
              <img src={arrow_forward} />
            </button>
          </div>
          <Page
            pageNumber={shownPage}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={width}
            className={
              "max-h-[85vh] min-h-full overflow-y-scroll rounded-b-xl pt-4"
            }
          ></Page>
        </Document>
      )}
    </div>
  );
};

export default ResumeDisplay;
